<template>
    <div class="programming" :class="{ modeHeat: modeHeat }">
        <div class="programming__time">
            <div class="days">
                <i
                    v-for="(day, key) in days"
                    :class="{ active: activeAdays.some((activeDay) => activeDay == key) }"
                    @click="addOrRemoveDay(key)"
                >
                    {{ day }}
                </i>
            </div>
            <div class="hours">
                <div class="hourFrom" data-label="inicio">
                    <input class="" type="time" :value="start" @input="$emit('update:start', $event.target.value)" />
                </div>
                <i class="timeLine"></i>
                <div class="hourTo" data-label="fin">
                    <input class="" type="time" :value="end" @input="$emit('update:end', $event.target.value)" />
                </div>
            </div>
        </div>
        <div class="d-flex">
            <div class="programming__order">
                <slot name="programmingOrder"></slot>
            </div>
            <div class="programming__switch">
                <slot name="programmingSwitch"></slot>
            </div>
        </div>
        <div class="programming__actions">
            <a class="btn btn--simple" @click="$emit('delete')">{{ resetText }}</a>
            <a class="btn btn--simple" @click="$emit('save')">{{ saveText }}</a>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        name: 'ui-Programming',
        data: function() {
            return {};
        },
        props: {
            start: String,
            end: String,
            days: {
                default: [],
            },
            activeAdays: {
                type: Array,
                default: [],
            },
            modeHeat: {
                type: Boolean,
                default: false,
            },
            resetText: String,
            saveText: String,
        },
        methods: {
            addOrRemoveDay(day) {
                const exists = this.activeAdays.some((activeDay) => activeDay == day);
                let result = this.activeAdays;

                if (exists) result = result.filter((activeDay) => activeDay != day);
                else result.push(day);

                this.$emit('update:activeAdays', result);
            },
        },
        computed: {},
    };
</script>
